module.exports = __webpack_public_path__ + "static/media/Background.fd0e9b21.png";